import { format, isAfter } from 'date-fns';

import { AbstractControl, ValidationErrors } from '@angular/forms';

import { ApValidDateValidator } from './valid-date.validator';

export class ApMaxDateValidator {
    /**
     * Validate that passed date is not after maxDate
     */
    public static validate(maxDate: Date): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            /**
             * This validator does not validate if the date is valid
             * If date is not valid at all no error from the maxDate validator
             */
            if (!ApValidDateValidator.isValid(control.value)) {
                return null;
            }

            return isAfter(control.value, maxDate) ? { maxDate: { maxDate: format(maxDate, 'dd-MM-yyyy'), value: control.value } } : null;
        };
    }
}
